module.exports = __webpack_public_path__ + "static/media/nl.8c9bb5ae.svg";